module.exports = __webpack_public_path__ + "static/img/pay.e4588ddd.png";